var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepositRequests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 35.582 32.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8427",
    "data-name": "Group 8427",
    transform: "translate(-1.1 -2.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25008",
    "data-name": "Path 25008",
    d: "M28.737,10.045h1.231a1.231,1.231,0,0,0-1.231-1.231Zm0,6.564h0ZM9.045,10.045V8.814a1.231,1.231,0,0,0-1.231,1.231Zm18.462,0v6.564h2.462V10.045Zm0,6.564V29.737h2.462V16.609ZM25.455,31.788H12.327V34.25H25.455ZM10.276,29.737V10.045H7.814V29.737ZM9.045,11.276H28.737V8.814H9.045Zm0-6.564H28.737V2.25H9.045ZM3.712,10.045A5.333,5.333,0,0,1,9.045,4.712V2.25A7.8,7.8,0,0,0,1.25,10.045Zm5.333,5.333a5.333,5.333,0,0,1-5.333-5.333H1.25A7.8,7.8,0,0,0,9.045,17.84Zm25.026-5.333a5.333,5.333,0,0,1-5.333,5.333V17.84a7.8,7.8,0,0,0,7.795-7.795Zm2.462,0A7.8,7.8,0,0,0,28.737,2.25V4.712a5.333,5.333,0,0,1,5.333,5.333ZM27.506,29.737a2.051,2.051,0,0,1-2.051,2.051V34.25a4.513,4.513,0,0,0,4.513-4.513ZM12.327,31.788a2.051,2.051,0,0,1-2.051-2.051H7.814a4.513,4.513,0,0,0,4.513,4.513Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25009",
    "data-name": "Path 25009",
    d: "M16.175,14.953a1.231,1.231,0,1,0,1.74-1.74Zm-1.251-2.992-.87.87Zm-2.321,0,.87.87ZM9.61,13.213a1.231,1.231,0,0,0,1.741,1.74Zm2.922,7.434a1.231,1.231,0,0,0,2.462,0Zm2.462-8.205a1.231,1.231,0,1,0-2.462,0Zm2.922.771-2.122-2.122-1.74,1.74,2.122,2.122Zm-6.183-2.122L9.61,13.213l1.741,1.74,2.122-2.122Zm4.061,0a2.871,2.871,0,0,0-4.061,0l1.74,1.74a.41.41,0,0,1,.58,0Zm-.8,9.556V12.442H12.532v8.205Z",
    transform: "translate(5.128 5.128)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositRequests);
export default __webpack_public_path__ + "static/media/DepositRequests.920427ba7b83280dd947c8d7816a7ee5.svg";
export { ForwardRef as ReactComponent };